function docKey(docType, docId) {
  return `${docType}:${docId}`;
}

function sameDoc(item, docType, docId) {
  return item.docType === docType && item.docId === docId;
}

function copyDeletedTodos(meta) {
  const src = meta && meta.deletedTodos && typeof meta.deletedTodos === "object" ? meta.deletedTodos : {};
  const out = {};
  for (const key of Object.keys(src)) {
    const map = src[key];
    if (map && typeof map === "object") out[key] = { ...map };
  }
  return out;
}

function emptySyncMeta() {
  return { docs: {}, deletes: [], deletedTodos: {} };
}

function markDirty(meta, docType, docId) {
  const key = docKey(docType, docId);
  const existing = meta.docs[key];
  return {
    docs: {
      ...meta.docs,
      [key]: {
        baseRevision: existing ? existing.baseRevision : 0,
        dirty: true,
      },
    },
    deletes: meta.deletes.slice(),
    deletedTodos: copyDeletedTodos(meta),
  };
}

function queueDelete(meta, docType, docId) {
  const key = docKey(docType, docId);
  const existing = meta.docs[key];
  const docs = { ...meta.docs };
  delete docs[key];
  const deletes = meta.deletes.slice();
  if (existing && existing.baseRevision !== 0) {
    deletes.push({ docType, docId, baseRevision: existing.baseRevision });
  }
  return { docs, deletes, deletedTodos: copyDeletedTodos(meta) };
}

function applySnapshot(meta, documents) {
  const docs = { ...meta.docs };
  const deletes = meta.deletes.slice();
  const serverKeys = new Set();

  for (const document of documents) {
    const key = docKey(document.docType, document.docId);
    serverKeys.add(key);
    const local = docs[key];
    const pendingDelete = deletes.some((item) => sameDoc(item, document.docType, document.docId));
    if ((local && local.dirty) || pendingDelete) continue;
    docs[key] = { baseRevision: document.revision, dirty: false };
  }

  for (const key of Object.keys(docs)) {
    if (serverKeys.has(key)) continue;
    if (docs[key].dirty) continue;
    const separator = key.indexOf(":");
    const docType = key.slice(0, separator);
    const docId = key.slice(separator + 1);
    if (deletes.some((item) => sameDoc(item, docType, docId))) continue;
    delete docs[key];
  }

  return { docs, deletes, deletedTodos: copyDeletedTodos(meta) };
}

function replaceWithSnapshot(documents, previousMeta) {
  const docs = {};
  for (const document of documents) {
    docs[docKey(document.docType, document.docId)] = {
      baseRevision: document.revision,
      dirty: false,
    };
  }
  return { docs, deletes: [], deletedTodos: copyDeletedTodos(previousMeta) };
}

function dropDelete(meta, docType, docId) {
  meta.deletes = meta.deletes.filter((item) => !sameDoc(item, docType, docId));
}

function applyPushResult(meta, docType, docId, response) {
  const key = docKey(docType, docId);
  if (response.status === 204) {
    delete meta.docs[key];
    dropDelete(meta, docType, docId);
    return;
  }
  if (response.status === 200 || response.status === 409) {
    if (response.doc) {
      meta.docs[key] = { baseRevision: response.doc.revision, dirty: false };
    }
    dropDelete(meta, docType, docId);
    if (response.status === 409 && response.doc) return { conflict: true };
    return;
  }
  if (response.status === 404) {
    delete meta.docs[key];
    dropDelete(meta, docType, docId);
    return { gone: true };
  }
}

module.exports = {
  docKey,
  emptySyncMeta,
  copyDeletedTodos,
  markDirty,
  queueDelete,
  applySnapshot,
  replaceWithSnapshot,
  applyPushResult,
};
